import {
    CREATE_BARCODE_MASTER_REQUEST,
    CREATE_BARCODE_MASTER_SUCCESS,
    CREATE_BARCODE_MASTER_FAILURE,
    DELETE_BARCODE_MASTER_REQUEST,
    DELETE_BARCODE_MASTER_SUCCESS,
    DELETE_BARCODE_MASTER_FAILURE,
    FETCH_SINGLE_BARCODE_MASTER_REQUEST,
    FETCH_SINGLE_BARCODE_MASTER_SUCCESS,
    FETCH_SINGLE_BARCODE_MASTER_FAILURE,
    FETCH_BARCODE_MASTER_REQUEST,
    FETCH_BARCODE_MASTER_SUCCESS,
    FETCH_BARCODE_MASTER_FAILURE,
    UPDATE_BARCODE_MASTER_REQUEST,
    UPDATE_BARCODE_MASTER_SUCCESS,
    UPDATE_BARCODE_MASTER_FAILURE,
    RESET_BARCODE_MASTER_INFO,
    CREATE_BARCODE_MASTER_FORM,
    UPDATE_BARCODE_MASTER_FORM,
    ADD_IMAGE_BARCODE_MODAL,
    CREATE_BARCODE_IMAGE_MASTER_FORM,
    FETCH_BARCODE_MASTER_SALES_ORDER_REQUEST,
    FETCH_BARCODE_MASTER_SALES_ORDER_SUCCESS,
    FETCH_BARCODE_MASTER_SALES_ORDER_FAILURE,
    FETCH_BARCODE_MASTER_STYLE_MASTER_REQUEST,
    FETCH_BARCODE_MASTER_STYLE_MASTER_SUCCESS,
    FETCH_BARCODE_MASTER_STYLE_MASTER_FAILURE,
    FETCH_BARCODE_MASTER_SUB_STYLE_REQUEST,
    FETCH_BARCODE_MASTER_SUB_STYLE_SUCCESS,
    FETCH_BARCODE_MASTER_SUB_STYLE_FAILURE,
    SHOW_ALL_SUB_STYLE_COLOR,
    SET_TEMP_GENERATE_GRID_DATA,
    CREATE_BARCODE_MASTER_WITH_GRID_REQUEST,
    CREATE_BARCODE_MASTER_WITH_GRID_SUCCESS,
    CREATE_BARCODE_MASTER_WITH_GRID_FAILURE,
    RESET_BARCODE_IMG_MASTER_INFO,
    FETCH_BARCODE_COPY_FROM_STYLE_REQUEST,
    FETCH_BARCODE_COPY_FROM_STYLE_SUCCESS,
    FETCH_BARCODE_COPY_FROM_STYLE_FAILURE,
    DELETE_BARCODE_BEFORE_UPDATE_REQUEST,
    DELETE_BARCODE_BEFORE_UPDATE_FAILURE,
    FETCH_PROGRAM_CAT_PRINT_REQUEST,
    FETCH_PROGRAM_CAT_PRINT_SUCCESS,
    FETCH_PROGRAM_CAT_PRINT_FAILURE
} from './barcodeMaster.actionsType';
import base64 from 'base-64';
import utf8 from 'utf8';

export const BARCODE_MASTER = 'barcodeMaster';

let initialState = {
    loading: false,
    showAllStyleColor: false,
    barcodeMaster: [],
    generateBarcodeDataList: [],
    barcodeMasterSalesOrder: [],
    templateId: '',
    barcodeMasterStyleMaster: [],
    barcodeCopyFromStyle: [],
    tempGenerateBarcodeGridData: {},
    barcodeMasterSubStyle: [],
    barcodeMasterForm: {},
    barcodeImageMasterForm: {
        applySelectedSzandClr: true,
        applySelectedAllSzandClr: false,
        applySelectedSzandAllClr: false,
        applySelectedAllSzandAllClr: false,
        applyCustom: false,
        selectedColor: [],
        selectedSize: []
    },
    errorMessage: '',
    barcodeImageModal: false

};

function urltoFile(url, filename, mimeType) {
    return fetch(url)
        .then(function (res) {
            return res.arrayBuffer();
        })
        .then(function (buf) {
            return new File([buf], filename, { type: mimeType });
        });
}

// urltoFile(
//                             `data:image/png;base64,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`,
//                             'blue-gradient-background-1',
//                             'image/png'
//                         ).then(function (file) {
//                             console.log(file, 'llllllllllll');
//                             return file;
//                         })

//Usage example:

export let barcodeMasterReducer = (state = initialState, action) => {
    let { type, payload, propertyId, updatePayload } = action;

    switch (type) {
        case FETCH_BARCODE_MASTER_REQUEST:
        case FETCH_BARCODE_COPY_FROM_STYLE_REQUEST:
        case FETCH_BARCODE_MASTER_SALES_ORDER_REQUEST:
        case FETCH_BARCODE_MASTER_STYLE_MASTER_REQUEST:
        case FETCH_BARCODE_MASTER_SUB_STYLE_REQUEST:
        case CREATE_BARCODE_MASTER_REQUEST:
        case CREATE_BARCODE_MASTER_WITH_GRID_REQUEST:
        case UPDATE_BARCODE_MASTER_REQUEST:
        case FETCH_SINGLE_BARCODE_MASTER_REQUEST:
        case DELETE_BARCODE_MASTER_REQUEST:
        case DELETE_BARCODE_BEFORE_UPDATE_REQUEST:
        case FETCH_PROGRAM_CAT_PRINT_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_BARCODE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                barcodeMaster: updatePayload
            };
        case FETCH_BARCODE_COPY_FROM_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                barcodeCopyFromStyle: updatePayload && updatePayload.map((x, i) => ({ ...x, fldId: i + 1 }))
            };
        case FETCH_BARCODE_MASTER_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                barcodeMasterSalesOrder: updatePayload && updatePayload.map((x, i) => ({ ...x, fldId: i + 1 }))
            };
        case FETCH_BARCODE_MASTER_SUB_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                barcodeMasterSubStyle: updatePayload
            };
        case FETCH_BARCODE_MASTER_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                barcodeMasterStyleMaster: updatePayload
            };

        case FETCH_PROGRAM_CAT_PRINT_SUCCESS:
            return {
                ...state,
                programCatPrintData: updatePayload || []
            }
        case CREATE_BARCODE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                // barcodeMasterForm: {},
                generateBarcodeDataList:
                    updatePayload &&
                    updatePayload.map((x, i) => ({
                        ...x,
                        fldId: i + 1,
                        convertImage: `data:image/${x?.fldExtension};base64,${x?.imageID}`
                    }))
                // showAllStyleColor: false
            };
        case CREATE_BARCODE_MASTER_WITH_GRID_SUCCESS:
            return {
                ...state,
                loading: false,
                barcodeMasterForm: {},
                generateBarcodeDataList: updatePayload,
                tempGenerateBarcodeGridData: [],
                barcodeCopyFromStyle: [],
                showAllStyleColor: false
            };
        case UPDATE_BARCODE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                barcodeMasterForm: {}
            };
        case SET_TEMP_GENERATE_GRID_DATA:
            return {
                ...state,
                loading: false,
                tempGenerateBarcodeGridData: payload
            };
        case SHOW_ALL_SUB_STYLE_COLOR:
            return {
                ...state,
                loading: false,
                showAllStyleColor: payload
            };
        case FETCH_SINGLE_BARCODE_MASTER_SUCCESS:
            // const convertBsse64ToFile = async (image, type, name) => {
            //     let fileObj = await fetch(`data:image/${type};base64,${image}`)
            //         .then((res) => {
            //             let blob = res.blob();
            //             let file = new File([blob], `${name}.${type}`, {
            //                 type: `image/${type}`
            //             });
            //             console.log(file, 'llllllllllllll');
            //             return file;
            //         })
            //         .then((data) => data)
            //         .catch((err) => console.log(err));
            //     return fileObj;
            // };
            return {
                ...state,
                loading: false,
                generateBarcodeDataList:
                    updatePayload &&
                    updatePayload.map((x, i) => ({
                        ...x,
                        fldId: i + 1,
                        convertImage: `data:image/${x?.fldExtension};base64,${x?.imageID}`
                    })),
                templateId: payload
            };
        case DELETE_BARCODE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case RESET_BARCODE_MASTER_INFO:
            return {
                ...state,
                barcodeMasterForm: {},
                tempGenerateBarcodeGridData: [],
                generateBarcodeDataList: [],
                barcodeCopyFromStyle: [],
                showAllStyleColor: false,
                templateId: ''
            };
        case RESET_BARCODE_IMG_MASTER_INFO:
            return {
                ...state,
                barcodeImageMasterForm: {
                    applySelectedSzandClr: true,
                    applySelectedAllSzandClr: false,
                    applySelectedSzandAllClr: false,
                    applySelectedAllSzandAllClr: false,
                    applyCustom: false
                }
            };
        case CREATE_BARCODE_MASTER_FORM:
        case UPDATE_BARCODE_MASTER_FORM:
            return {
                ...state,
                loading: false,
                barcodeMasterForm: {
                    ...state.barcodeMasterForm,
                    [payload.key]: payload.value
                }
            };
        case CREATE_BARCODE_IMAGE_MASTER_FORM:
            return {
                ...state,
                loading: false,
                barcodeImageMasterForm: {
                    ...state.barcodeImageMasterForm,
                    [payload.key]: payload.value
                }
            };
        case ADD_IMAGE_BARCODE_MODAL:
            return {
                ...state,
                loading: false,
                barcodeImageModal: payload
            };
        case FETCH_BARCODE_MASTER_FAILURE:
        case FETCH_BARCODE_COPY_FROM_STYLE_FAILURE:
        case FETCH_BARCODE_MASTER_SALES_ORDER_FAILURE:
        case FETCH_BARCODE_MASTER_STYLE_MASTER_FAILURE:
        case FETCH_BARCODE_MASTER_SUB_STYLE_FAILURE:
        case CREATE_BARCODE_MASTER_FAILURE:
        case CREATE_BARCODE_MASTER_WITH_GRID_FAILURE:
        case UPDATE_BARCODE_MASTER_FAILURE:
        case FETCH_SINGLE_BARCODE_MASTER_FAILURE:
        case DELETE_BARCODE_MASTER_FAILURE:
        case DELETE_BARCODE_BEFORE_UPDATE_FAILURE:
        case FETCH_PROGRAM_CAT_PRINT_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
